'use client';
var defaultResponseTransform = function(response) {
    return response.json();
};

export { defaultResponseTransform };
